import { useTranslation } from 'react-i18next';
import FactContainer from './FactContainer';

const FactOne = ({ history }) => {
  const { t } = useTranslation();
  return (
    <FactContainer
      history={history}
      factTitle={t('fact_1')}
      factDescription={{
        __html: t('fact_1_disclaimer'),
      }}
      nextUrl="q11"
      screenName="f1"
    />
  );
};

export default FactOne;
